import React, { useEffect, useState } from "react";
import { useIsFocused, useNavigation, useRoute } from "@react-navigation/native";
import i18n from "utils/i18n";
import _ from "lodash";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import { FormStatus } from 'utils/constants/form-constants';
import GraphqlBuilder from "utils/request/graphql/builder";
import { tableConstants } from "utils/constants/constants";
import MutationManagementTeam from "graphql/mutations/management/MutationManagementTeam";
import MutateTranslation from 'utils/mutate/translation'
import QueryManagementTeam from 'graphql/queries/management/QueryManagementTeam'
import { AppRoutes } from "navigations/app-routes";
import HelperManagementRights from "utils/helper-management-rights";
import { managementRightsConstants } from "utils/constants/management-right-constants";
import ObjectTeams from 'utils/objects/teams'
import TeamData from 'scenes/management/employees/components/team/data'
import TabbedContent from 'components/molecules/TabbedContent'
import TeamStatistics from 'scenes/management/employees/components/team/statistics'
import LoadingComponent from 'components/atoms/Loading'
import TeamEmployees from 'scenes/management/employees/components/team/employees'

const ManagementEmployeesTeamSceneComponent = () => {
	
	const navigation = useNavigation();
	const route = useRoute();
	const isFocused = useIsFocused();
	
	const teamGuid = _.get( route, ['params', 'teamGuid'], null );
	
	const [ loading, setLoading ] = useState( true )
	const [ team, setTeam ] = useState( {} )
	
	const saveForm = ( values, { callback } = {} ) => {
		new GraphqlBuilder()
			.addQuery( 'mutation', MutationManagementTeam, values )
			.setResultPath( ['mutation', 'team'], {} )
			.setOnStart( () => {
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				MutateTranslation.mutate( tableConstants.TEAMS, result.guid, values, {
					callbackSuccess: ( t ) => {
						callback( FormStatus.SUCCESS )
						
						navigation.replace( AppRoutes.MANAGEMENT_EMPLOYEES_TEAMS_VIEW, {
							teamGuid: result.guid
						});
					},
					callbackError: () => {
						callback( FormStatus.ERROR )
					}
				} )
			})
			.setOnError( ( result ) => {
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	const fetchTeam = () => {
		if( !_.isEmpty( teamGuid ) ) {
			new GraphqlBuilder()
				.addQuery( 'query', QueryManagementTeam, {
					guid: teamGuid
				})
				.setResultPath( ['query', 'team'], {} )
				.setOnSuccess( result => {
					setTeam( result )
					setLoading( false )
				})
				.setOnError( result => {
					setLoading( false )
				})
				.execute()
			
			return;
		}
		
		setTeam( ObjectTeams.defaults )
		setLoading( false )
	}
	
	useEffect( () => {
		return fetchTeam();
	}, [ isFocused, teamGuid ] )
	
	if( loading ) {
		return (
			<LoadingComponent />
		)
	}

	// Does the team exist?
	const teamExists = teamGuid !== null
	
	const tabBarItems = []
	
	if( teamExists ) {
		tabBarItems.push({
			key: 'statistics',
			text: i18n.t( 'management:form_block.title_statistic_other' ),
			scene: ( props ) => {
				return (
					<TeamStatistics
						{ ...props }
						team={ team }
					/>
				);
			}
		})
	}
	
	tabBarItems.push({
		key: 'data',
		text: i18n.t( 'management:form_block.title_default' ),
		scene: ( props ) => {
			return (
				<TeamData
					{ ...props }
					team={ team }
					saveForm={ saveForm }
				/>
			);
		}
	});
	
	if( teamExists && HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.EMPLOYEES ) ) {
		tabBarItems.push({
			key: 'employees',
			text: i18n.t('page.coworker.title'),
			scene: ( props ) => {
				return (
					<TeamEmployees
						{ ...props }
						team={ team }
					/>
				);
			}
		});
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t('management:pages.teams.team.title') }
				topNavigation={true}
				showBackButton={true}>
				
				<TabbedContent
					items={ tabBarItems }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

export default ManagementEmployeesTeamSceneComponent
